const data = [
	{
		Course: `Post Doctoral
        fellowship (PDF)`,
		"College/ University": `Lincoln University, Malaysia`,
		"Percentage of Marks": `Defended on 25th June 2021`,
		Division: ``,
	},
	{
		Course: `PhD.
        (CSE)`,
		"College/ University": `Completed from Savitribai Phule 
        Pune University (SPPU)
        Research Center: SKNCOE, Pune
        Guide Name: Dr. Rajesh S. Prasad`,
		"Percentage of Marks": `Defended on 24th November 2018`,
		Division: ``,
	},
	{
		Course: `M.Tech.(CSE)`,
		"College/ University": `Vishweshraiya Technological 
        University(V.T.U), 
        Belgaum(Karnataka)`,
		"Percentage of Marks": `72`,
		Division: `First`,
	},
	{
		Course: `B.E
        (CE)`,
		"College/ University": `North Maharastra University
        (N.M.U), Jalgaon (M.S) `,
		"Percentage of Marks": `64`,
		Division: `First`,
	},
];
export default data;
